/**
 * Private modules
 */
const {
  createQueryComponent,
  customerId,
  date,
  drawId,
  objectId,
  systemGameId,
} = require('../.private').components;

/**
 * Scopes
 */
const {
  DEFAULT,
  DRAWS_INPUT_BY_SYSTEM_GAME_ID,
  DRAWS_OPEN_BY_SYSTEM_GAME_ID,
  DRAW_CUSTOMERS_INPUT,
} = require('../../scopes');

module.exports = {
  createDrawBySystemGameId: {
    properties: {
      body: {
        properties: {
          date,
          systemGameTypeIds: {
            items: {
              oneOf: [
                {
                  pattern: '^\\d+$',
                  type: 'string',
                },
                {
                  type: 'number',
                },
              ],
            },
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
        },
        required: [
          'date',
          'systemGameTypeIds',
        ],
        type: 'object',
      },
      params: {
        properties: {
          systemGameId,
        },
        required: ['systemGameId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getDrawById: {
    properties: {
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDrawCreditByCustomerId: {
    properties: {
      params: {
        properties: {
          customerId,
          drawId,
        },
        required: [
          'customerId',
          'drawId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDrawCustomers: {
    properties: {
      params: {
        properties: {
          drawId,
        },
        required: ['drawId'],
        type: 'object',
      },
      query: createQueryComponent([
        DEFAULT,
        DRAW_CUSTOMERS_INPUT,
      ]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDrawsBySystemGameId: {
    properties: {
      params: {
        properties: {
          systemGameId,
        },
        required: ['systemGameId'],
        type: 'object',
      },
      query: createQueryComponent([
        DEFAULT,
        DRAWS_INPUT_BY_SYSTEM_GAME_ID,
        DRAWS_OPEN_BY_SYSTEM_GAME_ID,
      ]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
};
